import React, { Fragment, useEffect, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectDivisionsDrillDown,
  makeSelectDimensions,
  makeSelectIsLoadingDivisions,
  makeSelectMetric,
} from "./selectors"
import { getDivisionsByDimensionWatcher, getDivisionsWatcher } from "./actions"

import "../../../Reports/components/ClimateMeasurement/components/WidgetResultByDivision/index.less"

import {
  isAmbassadorActive,
  isModeInModuleBySlug,
  KEY_CHECKBOX_EXCLUDE,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
  setItem,
} from "../../../utils/storage"
import { validate } from "../../../utils/functions"
import { Checkbox, Popover, Spin, Tooltip, TreeSelect } from "antd"
import { Link } from "react-router-dom"
import {
  DISABLE,
  RESULT_BY_DIMENSION,
  RESULT_BY_DIVISION,
} from "../../../utils/constants"
import { generateTree } from "../../../utils/utils"
import { QuestionCircleFilled } from "@ant-design/icons"
import BarChartDivisionNotHistory from "../../../components/Recharts/BarChartDivisionNotHistory"

const { TreeNode } = TreeSelect

export function WidgetResultByDivision(props) {
  const [checkboxExclude, setCheckboxExclude] = useState(
    LOCAL_CHECKBOX_EXCLUDE() == "true"
  )
  const [selectedFilter, setSelectedFilter] = useState(undefined)

  useEffect(() => {
    initGetData()
    // divisionsData se recarga (getStatus) al cambiar división/segmento: depender también de
    // idDivisionSelected/selectedSegment disparaba antes con los datos anteriores (doble carga, VLENG-12055)
  }, [props.idMeasure, props.divisionsData])

  const initGetData = () => {
    const {
      idMeasure,
      getDivisions,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
      dimensionsData,
      divisionsData,
    } = props

    if (!validate.exist(idMeasure) || !validate.exist(measureGeneral)) return
    if (!divisionsData || !divisionsData.data) return

    const params = {
      divisionsData,
      dimensionsData,
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() === "true" &&
        LOCAL_ISOLATED_METRICS() === "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
      id_segment: selectedSegment,
    }
    if (measureGeneral.is_engagement) {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }

    getDivisions(params)
  }

  const changeDimension = (value, exclude = false) => {
    const {
      measureGeneral,
      idMeasure,
      selectedSegment,
      divisionsData,
      idDivisionSelected,
      idDivisionParent,
      getDivisionsByDimension,
    } = props
    const params = {
      divisionsData,
      dimension: value,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      isExclude: exclude,
      params: {
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
      id_segment: selectedSegment,
    }
    if (measureGeneral.is_engagement) {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }
    getDivisionsByDimension(params)
  }

  const divisionID = props.idDivisionSelected
  const isAmbassador = isAmbassadorActive()
    ? validate.exist(divisionID)
      ? `id_division=${divisionID}`
      : `id_division=${props.idDivisionParent}`
    : ""

  const onChangeSelectedFilter = (s, extra) => {
    setSelectedFilter(s)
    changeDimension(
      extra.triggerNode && extra.triggerNode.props
        ? extra.triggerNode.props.idSelected
        : undefined,
      checkboxExclude
    )
  }

  const changeExcludeCheckbox = (checked) => {
    setItem(KEY_CHECKBOX_EXCLUDE, checked)
    setCheckboxExclude(checked)
    changeDimension(selectedFilter, checked)
  }

  const newDimensions = (props.dimensions || []).filter((e) => {
    if (!e.engagement) return e
  })

  const renderExcludeDivision = () => {
    if (LOCAL_ISOLATED_METRICS() != "true") {
      return null
    }
    return (
      <div
        style={{
          marginLeft: "auto",
          paddingRight: 20,
          height: 30,
          paddingTop: 5,
        }}>
        <Checkbox
          checked={checkboxExclude}
          onChange={(e) => changeExcludeCheckbox(e.target.checked)}>
          Excluir subdivisiones
        </Checkbox>
        <Popover
          placement="top"
          content={
            <div style={{ maxWidth: 245, textAlign: "center" }}>
              Activa el checkbox para visualizar los
              <br />
              resultados únicamente de las
              <br />
              divisiones superiores, <b>excluyendo</b> los
              <br />
              resultados de sus subdivisiones.
            </div>
          }>
          <QuestionCircleFilled
            style={{
              color: "#D8D8D8",
              verticalAlign: "baseline",
              fontSize: "12px",
            }}
          />
        </Popover>
      </div>
    )
  }

  const headerDimension = () => {
    const { metric, idMeasure, measureGeneral, selectedSegment } = props
    let isRedirect = false
    if (!metric) {
      isRedirect = isModeInModuleBySlug(RESULT_BY_DIMENSION)
    } else {
      isRedirect = isModeInModuleBySlug(RESULT_BY_DIVISION)
    }
    let newDimensionsAux = [...newDimensions]
    newDimensionsAux = generateTree(
      "id",
      "id_parent",
      newDimensionsAux,
      "childs",
      false
    )

    let querySegment = ""
    let queryDivision = ""
    let queryParams = ""

    if (isAmbassador !== "") {
      queryDivision = isAmbassador
    }

    if (measureGeneral.segments.length > 1 && selectedSegment) {
      querySegment = `&id_segment=${selectedSegment}`
    }

    if (queryDivision !== "" || querySegment !== "") {
      queryParams = `${"?home=true"}&${queryDivision}${querySegment}`
    }

    return (
      <div className="WidgetResultByDivision-Header">
        <div className="WidgetResultByDivision-Header-Title">
          <span>Resultado por división</span>
          {isRedirect !== DISABLE && (
            <div className="WidgetResultByDivision-Header-Link">
              <span>
                <Link
                  to={`/reports/measure/${idMeasure}/divisions${queryParams}`}>
                  {"Ir a ranking de divisiones >"}
                </Link>
              </span>
            </div>
          )}
        </div>
        <div className="WidgetResultByDivision-Header-Filters">
          {renderExcludeDivision()}
          <div>
            <TreeSelect
              style={{ width: 200 }}
              placeholder="Seleccionar dimensión"
              showSearch
              allowClear
              value={selectedFilter}
              treeNodeFilterProp="title"
              onChange={(s, c, extra) => onChangeSelectedFilter(s, extra)}>
              {newDimensionsAux.map((e) => {
                return (
                  <TreeNode
                    idSelected={e.id}
                    value={e.id}
                    title={e.name}
                    key={e.id}>
                    {e.childs &&
                      e.childs.map((child) => {
                        return (
                          <TreeNode
                            value={child.id}
                            key={child.id}
                            idSelected={child.id}
                            title={
                              <Tooltip title={child.name}>{child.name}</Tooltip>
                            }
                          />
                        )
                      })}
                  </TreeNode>
                )
              })}
            </TreeSelect>
          </div>
        </div>
      </div>
    )
  }

  const chartDivision = () => {
    if (props.isLoadingDivisions) {
      return (
        <Fragment>
          <div className="WidgetResultByDivision-Chart loadingSpin">
            <Spin size="large" />
          </div>
        </Fragment>
      )
    }
    return (
      <div className="WidgetResultByDivision-Chart">
        <BarChartDivisionNotHistory
          legendVerticalAlign="bottom"
          legendMargin={{}}
          metric={props.metric}
          divisionsDrillDown={props.divisionsDrillDown}
          calculationType={props.measureGeneral.id_survey_calculation_type}
        />
      </div>
    )
  }

  return (
    <div className="WidgetResultByDivision">
      {headerDimension()}
      {chartDivision()}
    </div>
  )
}

WidgetResultByDivision.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingDivisions: PropTypes.bool,
  divisionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  dimensions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  metric: PropTypes.object,
  getDivisions: PropTypes.func,
  getDivisionsByDimension: PropTypes.func,
  selectedSegment: PropTypes.number,
  dimensionsData: PropTypes.object,
  divisionsData: PropTypes.object,
}

const mapStateToProps = createStructuredSelector({
  isLoadingDivisions: makeSelectIsLoadingDivisions(),
  divisionsDrillDown: makeSelectDivisionsDrillDown(),
  dimensions: makeSelectDimensions(),
  metric: makeSelectMetric(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDivisions: (params) => dispatch(getDivisionsWatcher(params)),
    getDivisionsByDimension: (params) =>
      dispatch(getDivisionsByDimensionWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetResultByDivisionV2", reducer })
const withSaga = injectSaga({ key: "widgetResultByDivisionV2", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetResultByDivision)
